import { AccountInformationFieldNames } from '@contracts/order/fields/AccountInformationFields';
import { BooleanField } from '@src/permitField/PermitFields';

export class BilingualField extends BooleanField {
  public static fieldName = AccountInformationFieldNames.Bilingual;
}

export const accountFields = {
  [BilingualField.fieldName]: BilingualField.validator,
};
